// This file generates PKCE codes (code verifier, code challenge, state, and nonce) for OAuth flows.
import { generateCodeChallenge } from "./generateCodeChallenge";
import { generateCodeVerifier } from "./generateCodeVerifier";
import { generateNonce } from "./generateNonce";
import { generateState } from "./generateState";

export async function generatePKCECodes() {
  const codeVerifier = await generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  const state = generateState();
  const nonce = generateNonce();
  return { codeVerifier, codeChallenge, state, nonce };
}
